<template>
  <div>
    <div class="page page__list" v-if="!isIQC">
      <search-bar
        @search="onSearch"
        name="va_code,va_vendname"
        placeholder="输入单据编号、供应商进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/purchase/verify_apply/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.va_vendname}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.va_date}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.va_class}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.va_status!='已审核'}"
            >{{item.va_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>
    <div class="page page__list" v-if="isIQC">
      <search-bar
        @search="onSearch"
        name="iqc_code,iqc_vendname"
        placeholder="输入单据编号、供应商进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/qc/iqc/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.iqc_code}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.iqc_date}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.pr_detail}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.iqc_status!='已审核'}"
            >{{item.iqc_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>
  </div>

</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isIQC: false,
      listUrl: "/api/storage/purcverifyapply/list",
      params: {
        size: 99999,
        limit: 20,
        page: 1,
        start: 0,
        caller: "purcverifyapply"
      },
      filters: [
        {
          type: "date",
          name: "va_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "va_status!='已审核'",
              mode: "MAIN"
            },
            {
              value: 2,
              label: "已审核",
              condition: "va_status='已审核'",
              mode: "DETAIL"
            },
            {
              value: 3,
              label: "待入库",
              condition: "iqc_status='已审核' and (iqc_okturnstatus ='未入库' and iqc_okqty > 0)",
              mode: "DETAIL"
            },
            {
              value: 4,
              label: "已入库",
              condition: "iqc_status='已审核' and (iqc_ngturnstatus ='未退货' and iqc_ngqty > 0)",
              mode: "DETAIL"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isIQC = filter.value > 2
      this.listUrl = isIQC ? '/api/storage/purciqc/list' : '/api/storage/purcverifyapply/list'
      this.filters[0].name = isIQC ? 'iqc_date' : 'va_date'
      this.isIQC = isIQC
      filterBar.initConfig()
      next()
    },
  }
};
</script>